<template>
  <div>
    <v-switch
      :label="$t('medkitlogs.firstAidKitUsed')"
      data-cy="med"
      v-model="value.med"
    ></v-switch>
  </div>
</template>
<script>
export default {
  props: ["value"],
  data: () => ({}),
  methods: {},
};
</script>
